import { useMutation, useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { fetch5, fetch3 } from "../commonApis/commonApis";

const url = process.env.REACT_APP_BASE_URL;
 
export const useAramexBulkForwardMutation = () => {
  return useMutation({
    mutationFn: async (payload: {
      orderIds: string[];
      noOfPieces?: number;
      clientId: string;
      warehouse: string;
    }) => {
      if (!payload.orderIds?.length) throw new Error("No orders selected");
      if (payload.orderIds.length > 200) throw new Error("Maximum 200 orders per bulk request");
 
      const res = await fetch5(`${url}/api/bulk/aramex-bulk-forward`, "POST", payload);
      if (!res.success) throw res.message || "Aramex bulk forward failed";
      return res;
    },
    onSuccess: (res: any) => {
      // toast.success(
      //   `Aramex bulk forward job queued (${res?.data?.jobId ? `Job: ${res.data.jobId.slice(0, 8)}...` : ""}). You'll be notified when complete.`
      // );
      console.log("Aramex bulk forward initiated:", res);
    },
    onError: (err: any) => toast.error(String(err) || "Aramex bulk forward failed"),
  });
};

 
export const useAramexBulkLabelPrintMutation = () => {
  return useMutation({
    mutationFn: async (payload: {
      orderIds: string[];
      labelFormat?: string;
      labelsize?: string;
    }) => {
      if (!payload.orderIds?.length) throw new Error("No orders selected");
      if (payload.orderIds.length > 100) throw new Error("Maximum 100 labels per bulk request");
 
      const res = await fetch5(`${url}/api/bulk/aramex-bulk-label-print`, "POST", payload);
      if (!res.success) throw res.message || "Aramex bulk label print failed";
      return res;
    },
    onSuccess: (res: any) => {
      // toast.success(
      //   `Aramex label print job queued (${res?.data?.jobId ? `Job: ${res.data.jobId.slice(0, 8)}...` : ""}). You'll be notified when labels are ready.`
      // );
      console.log("Aramex bulk label print initiated:", res);
    },
    onError: (err: any) => toast.error(String(err) || "Aramex label print failed"),
  });
};
 

 
export const useAramexJobStatus = (jobId?: string) => {
  return useQuery({
    queryKey: ["aramexJobStatus", jobId],
    queryFn: async () => {
      const res = await fetch3(`${url}/api/bulk/jobs/${jobId}`, "get");
      if (!res?.data) return null;
      return res.data;
    },
    enabled: !!jobId,
    refetchInterval: (data: any) => {
      if (data?.status === "COMPLETED" || data?.status === "FAILED") return false;
      return 3000; 
    },
    staleTime: 0,
  });
};
 

// Aramex Return / Reverse Shipment
export const useAramexBulkReverseMutation = () => {
  return useMutation({
    mutationFn: async (payload: {
      orderIds: string[];
      clientId?: string;
      noOfPieces?: number;
    }) => {
      if (!payload.orderIds?.length) throw new Error("No orders selected");
      if (payload.orderIds.length > 200) throw new Error("Maximum 200 orders per bulk request");
 
      const res = await fetch5(`${url}/api/aramex/bulk-reverse`, "POST", payload);
      if (!res.success) throw res.message || "Aramex bulk reverse failed";
      return res;
    },
    onSuccess: (res: any) => {
      console.log("Aramex bulk reverse initiated:", res);
    },
    onError: (err: any) => toast.error(String(err) || "Aramex bulk reverse failed"),
  });
};

export const useAramexReverseShipmentMutation = () => {
  return useMutation({
    mutationFn: async (payload: {
      orderId: string;
      noOfPieces?: number;
      clientId?: string;
    }) => {
      const { orderId, ...rest } = payload;
      if (!orderId) throw new Error("Order ID is required for reverse shipment");
 
      const res = await fetch5(`${url}/api/aramex/reverse-shipment/${orderId}`, "POST", rest);
      if (!res.success) throw res.message || "Aramex reverse shipment failed";
      return res;
    },
    onSuccess: (res: any) => {
      toast.success(`Aramex reverse shipment created successfully!`);
    },
    onError: (err: any) => toast.error(String(err) || "Aramex reverse shipment failed"),
  });
} ;

